import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import styled from 'styled-components';

import { VFlex } from '@/components/base';
import {
  DASHBOARD_ROW_DEFAULT_HEIGHT,
  Dashboard2ColumnType,
} from '@/features/Dashboard/types';
import { customScrollbar } from '@/styles/style';

import type { ReportT } from '../../types';
import { reportUtils } from '../../utils';
import ReportRow from '../ReportEditor/ReportRow';
import ReportRowHandler from '../ReportEditor/ReportRowHandler';

type Props = {
  report: ReportT;
};

const ReportDetailBody = (props: Props) => {
  const { report } = props;
  const mappedReport = reportUtils.mapReport(report);
  return (
    <Style>
      <DndProvider backend={HTML5Backend}>
        <div>
          <ReportRowHandler rowIndex={0} rows={mappedReport.mapped_rows} />
        </div>
        {mappedReport.mapped_rows?.map((row, index) => (
          <div key={row.alias}>
            <ReportRow
              report={mappedReport}
              row={row}
              rowHeight={
                row.mapped_columns.length === 1 &&
                row.mapped_columns.every(
                  (col) =>
                    col.item.type ===
                    Dashboard2ColumnType.DASHBOARD_COLUMN_TEXT_BOX,
                )
                  ? 'auto'
                  : row.height || DASHBOARD_ROW_DEFAULT_HEIGHT
              }
            />
            <ReportRowHandler
              rowId={row.alias}
              rowIndex={index + 1}
              rows={mappedReport.mapped_rows}
            />
          </div>
        ))}
      </DndProvider>
    </Style>
  );
};

const Style = styled(VFlex)`
  flex: 1;
  padding: 12px 12px 12px 28px;
  overflow: auto;
  scrollbar-gutter: stable;
  ${customScrollbar};
`;

export default ReportDetailBody;
